var _path, _path2, _path3, _path4, _path5, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlantBook = function SvgPlantBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 95,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    d: "m103.484 94.349 1.088-93.243L39.68.35 38.59 93.592z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "m98.977 13.78-53.939-.629-.064 5.474 53.939.63zM96.035 23.994l-48.3-.564-.059 5.065 48.3.564z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    stroke: "#169B62",
    strokeWidth: 2,
    d: "M18.687 33.723c-2.847-5.068-9.03-7.3-14.58-5.235 2.836 5.05 9.001 7.292 14.58 5.235ZM21.938 33.427c1.948-5.504 7.659-8.816 13.472-7.782-1.94 5.483-7.63 8.802-13.472 7.782ZM21.937 43.784c1.947-5.504 7.658-8.816 13.471-7.782-1.94 5.482-7.63 8.802-13.472 7.782ZM17.949 24.529c-2.192-3.651-6.692-5.276-10.8-3.874 2.183 3.636 6.671 5.27 10.8 3.874ZM21.112 24.242c1.542-3.99 5.698-6.401 9.98-5.76-1.535 3.974-5.678 6.39-9.98 5.76ZM17.862 18.118c-1.021-4.151-4.839-7.057-9.165-6.953 1.016 4.135 4.82 7.045 9.165 6.953ZM20.218 15.477c-.483-4.252 2.08-8.351 6.163-9.82.482 4.235-2.067 8.333-6.163 9.82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#169B62",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20.48 15.038c-1.611.589-1.23 27.988 7.634 71.767"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M46.514 53.332H.084v19.083h46.43z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.172,
    cy: 20.509,
    fill: "#D9D9D9",
    rx: 23.172,
    ry: 20.509,
    transform: "matrix(-1 0 0 1 46.43 53.332)"
  })));
};
export { SvgPlantBook as ReactComponent };
export default __webpack_public_path__ + "images/plant-book.svg";